<template>
    <!-- <div class="Content padding-20 bgc box-shadow"> -->
    <div class="Content">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'Content',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Content {
    // margin-top: 20px;
}
</style>
